import apiClient from "../../../service/apiClient";
import { ADMIN_CONTACT_ENDPOINTS, ADMIN_EMAIL_ENDPOINTS, ADMIN_PANEL_ENDPOINTS, USER_PROFILE_ENDPOINTS } from "../../../app/apiEndpoints";

export const getContactSummary = () => {
  return apiClient.get(ADMIN_CONTACT_ENDPOINTS.GET_CONTACT_SUMMARY);
};

export const getContactGridData = (name, email, stausid) => {
  return apiClient.get(ADMIN_CONTACT_ENDPOINTS.GET_CONTACTS,{params:{contactName:name,emailAddress:email,statusId:stausid}})
}

export const getContactMenuPermissions = (contactId) => {
  return apiClient.get(ADMIN_CONTACT_ENDPOINTS.GET_CONTACT_MENU_PERMISSIONS + `/${contactId}`);
}

export const getActivityHistory = (userId, contactId, fromDate, toDate) => {
  return apiClient.get(ADMIN_PANEL_ENDPOINTS.GET_PAGE_TRACKING_DETAILS, {
    params: { userId, contactId, fromDate, toDate },
  });
};

export const getActivityHistoryUsers = () => {
  return apiClient.get(ADMIN_PANEL_ENDPOINTS.GET_ADMIN_USERS);
};

export const getActivityHistoryContacts = () => {
  return apiClient.get(ADMIN_CONTACT_ENDPOINTS.GET_CONTACTS, {
    params: { contactName: "", emailAddress: "", statusId: 0 },
  });
};

export const getContactInfo = (contactId) => {
  return apiClient.get(ADMIN_PANEL_ENDPOINTS.GET_CONTACT_USER_INFO, {
    params: { contactId },
  });
};

export const getEmailHistoryByContact = (emailStatus = 4) => {
  return apiClient.get(ADMIN_CONTACT_ENDPOINTS.GET_EMAIL_HISTORY_BY_CONTACT, {
    params: { emailStatus },
  });
};

export const updateSubscriptions = (data) => {
  return apiClient.post(ADMIN_CONTACT_ENDPOINTS.UPDATE_SUBSCRIPTIONS,data)
}

export const getContactCustomize = (pageId, userId, name) => {
  return apiClient.get(
    `${ADMIN_CONTACT_ENDPOINTS.GET_CONTACT_CUSTOMIZE}/${pageId},${userId},'${name}'`
  );
};

export const getInitialAccessTemplate = () => {
  return apiClient.get(ADMIN_EMAIL_ENDPOINTS.GET_EMAIL_TEMPLATE_LIST)
}

export const saveContactCustomize = (payload) => {
  return apiClient.post(ADMIN_CONTACT_ENDPOINTS.SAVE_CONTACT_CUSTOMIZE, payload);
};

export const sendInitialAccessMail = (payload) => {
  return apiClient.post(ADMIN_EMAIL_ENDPOINTS.SEND_INITIAL_ACCESS_MAIL,payload)
}

export const resetContactMfa = (userId) => {
  return apiClient.post(USER_PROFILE_ENDPOINTS.RESET_MFA, {
    userId,
    type: "Contact",
  });
};
